module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/level-iterator-stream/~/isarray/index.js
// module id = 1477
// module chunks = 0 1 2